import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Card, CardBody, CardText, CardTitle, Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { getFile, downloadFile } from "../../../../slices/thunks";
import { toast } from "react-toastify";
import OPlaceholder from "../../../../Components/OElements/OPlaceholder";

const PowerGenerationSourceFilesModal = ({ dataPowerGenerationSource, isOpen, handleToggleModal }) => {
    const dispatch = useDispatch();

    const [documentIds, setDocumentIds] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [fileDownloadLoading, setFileDownloadLoading] = useState(null);
    const [loading, setLoading] = useState(false);

    // Update document IDs whenever dataPowerGenerationSource changes
    useEffect(() => {
        const listDocuments = [];
        if (dataPowerGenerationSource) {

            if (dataPowerGenerationSource.document_initial_operation) {
                listDocuments.push(dataPowerGenerationSource.document_initial_operation);
            }
            if (dataPowerGenerationSource.certificate_of_origin) {
                listDocuments.push(dataPowerGenerationSource.certificate_of_origin);
            }
            setDocumentIds(listDocuments);
        }
    }, [dataPowerGenerationSource]);

    // Fetch documents asynchronously
    useEffect(() => {
        const fetchFiles = async () => {
            setDocuments([]);
            if (documentIds.length > 0) {
                setLoading(true);
                try {
                    const files = await Promise.all(
                        documentIds.map(async (documentId) => {
                            const response = await dispatch(getFile(documentId));
                            return { id: documentId, data: response.payload };
                        })
                    );
                    setDocuments(files);
                } catch (error) {
                    console.error("Error fetching files: ", error);
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchFiles();
    }, [documentIds, dispatch]);

    const handleDownloadFile = (file) => {
        setFileDownloadLoading(file._id); // Aquí puedes mostrar un indicador de carga si es necesario
        dispatch(downloadFile({ file_id: file._id }))
            .then(data => {
                const payload = data.payload;
                const url = window.URL.createObjectURL(payload);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${file.filename}${file.extension}`);
                document.body.appendChild(link);
                link.click();
                link.remove(); // Remover el enlace del DOM después de la descarga
            })
            .finally(() => setFileDownloadLoading(null)); // Aquí puedes ocultar el indicador de carga
    };

    return (
        <div>
            <Modal
                isOpen={isOpen}
                toggle={handleToggleModal}
                size="lg"
                className="border-0"
                modalClassName="modal fade zoomIn"
                backdrop="static"
                centered={true}
            >
                <ModalHeader toggle={handleToggleModal}>Documentos de la fuente de generación de energia: {dataPowerGenerationSource.serial_number}</ModalHeader>
                <ModalBody>
                    <Row>
                        {loading ? (
                            <OPlaceholder />
                        ) : documents.length > 0 ? (
                            documents.map((item, index) => (
                                <Col key={item.id} md={6}>
                                    <Card className="border">
                                        <CardBody>
                                            <Row>
                                                <Col md={2}>
                                                    <i className={`${Icons.guide} ri-3x`}></i>
                                                </Col>
                                                <Col>
                                                    <CardTitle tag="h5" className="mt-2">
                                                        {item.data?.file_type?.name || 'Documento'}
                                                    </CardTitle>
                                                    <CardText>{/* Agregar detalles del archivo aquí */}</CardText>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                        <CardBody>
                                            <button
                                                className="btn btn-primary btn-sm"
                                                onClick={() => handleDownloadFile(item.data)}
                                            >
                                                <i className="icon-download ri-lg px-1"></i>Descargar
                                            </button>
                                        </CardBody>
                                    </Card>
                                </Col>
                            ))
                        ) : (
                            <Col className="text-center">
                                <p>No hay documentos disponibles.</p>
                            </Col>
                        )}
                    </Row>
                </ModalBody>
            </Modal>
        </div>
    );
};

export default PowerGenerationSourceFilesModal;
